import React from "react";
import EvidencePin from "./EvidencePin";

export const DossierFolder = ({ tab, pin = "brass", className = "", children }) => (
  <div className={`dossier-folder ${className}`}>
    <div className="dossier-folder-tab">{tab}</div>
    {pin ? <EvidencePin color={pin} className="dossier-folder-pin" /> : null}
    <div className="dossier-folder-body">{children}</div>
  </div>
);

export default DossierFolder;
